export default __webpack_public_path__ + "static/media/control.f11bbec5.png";